import classNames from 'classnames';
import { useState, useEffect/* , useRef */ } from 'react';
// import { TbTargetArrow } from "react-icons/tb";
// import { BiSupport } from "react-icons/bi";
// import { FaChalkboardTeacher } from "react-icons/fa";
// import { FiSettings } from "react-icons/fi";
// import { HiOutlineRocketLaunch } from "react-icons/hi2";
import { FaVideo } from "react-icons/fa";
import History from 'constants/history';

// const Icon1 = TbTargetArrow as React.FC<any>;
// const Icon2 = BiSupport as React.FC<any>;
// const Icon3 = FaChalkboardTeacher as React.FC<any>;
// const Icon4 = FiSettings as React.FC<any>;
// const Icon5 = HiOutlineRocketLaunch as React.FC<any>;
const Icon8 = FaVideo as React.FC<any>;

export const D_MARKETING_PREFIX = "digital-marketer";
export const SUPPORT_PREFIX = "support";
export const TEACHER_PREFIX = "teacher";
export const OPERATOR_PREFIX = "operator";
export const STARTUP_PREFIX = "startup";
export const WEBINAR_PREFIX = "webinar";

// Sticky header items configuration
const stickyHeaderItems = [
  // {
  //   des: "5 Marketing Agents",
  //   role: "AI Marketing",
  //   bg: "bg-[#9F8AF1]",
  //   icon: <Icon1 />,
  //   prefix: D_MARKETING_PREFIX,
  //   glowColor: "#9F8AF1"
  // },
  // {
  //   des: "4 AI Teachers",
  //   role: "Teaching",
  //   bg: "bg-[#488EFB]",
  //   icon: <Icon3 />,
  //   prefix: TEACHER_PREFIX,
  //   glowColor: "#488EFB"
  // },
  // {
  //   des: "4 AI Support Agents",
  //   role: "AI Support",
  //   bg: "bg-[#FF8069]",
  //   icon: <Icon2 />,
  //   prefix: SUPPORT_PREFIX,
  //   glowColor: "#FF8069"
  // },
  // {
  //   des: "4 Admin Staff",
  //   role: "Operations",
  //   bg: "bg-[#00c3b2]",
  //   icon: <Icon4 />,
  //   prefix: OPERATOR_PREFIX,
  //   glowColor: "#00c3b2"
  // },
  // {
  //   des: "3 Startups Assistant",
  //   role: "Startups",
  //   bg: "bg-[#FFB700]",
  //   icon: <Icon5 />,
  //   prefix: STARTUP_PREFIX,
  //   glowColor: "#FFB700"
  // },
  {
    des: "Live Webinars",
    role: "Webinar",
    bg: "bg-[#EF4444]",
    icon: <Icon8 />,
    prefix: WEBINAR_PREFIX,
    glowColor: "#EF4444",
    path: "/v2#webinar"
  },
];

interface StickyHeaderProps {
  renderComponents?: any[];
  sectionRefs?: React.MutableRefObject<any[]>;
  onScrollUp?: () => void;
  showWhen?: 'always' | 'scroll'; // Control visibility behavior
  scrollThreshold?: number; // Scroll position to show sticky header
  activePrefix?: string; // Manually set active item by prefix
}

const StickyHeader: React.FC<StickyHeaderProps> = ({
  renderComponents = [],
  sectionRefs,
  onScrollUp,
  showWhen = 'scroll',
  scrollThreshold = 100,
  activePrefix
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(showWhen === 'always');

  // Helper function to get item index from section ID
  const getItemIndexFromSectionId = (sectionId: string) => {
    if (!sectionId) return 0;

    for (let i = 0; i < stickyHeaderItems.length; i++) {
      if (sectionId.startsWith(stickyHeaderItems[i].prefix)) {
        return i;
      }
    }
    return 0;
  };

  // Calculate card position in carousel
  const getCardPosition = (index: number) => {
    const offset = (index - currentIndex + stickyHeaderItems.length) % stickyHeaderItems.length;

    if (offset === 0) return 'center';
    if (offset === 1) return 'right-1';
    if (offset === 2) return 'right-2';
    if (offset === stickyHeaderItems.length - 1) return 'left-1';
    if (offset === stickyHeaderItems.length - 2) return 'left-2';
    return 'hidden';
  };

  // Get card styles based on position
  const getCardStyles = (position: string) => {
    const baseStyle = {
      transition: 'all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    };

    switch (position) {
      case 'center':
        return {
          ...baseStyle,
          transform: 'translateX(0) scale(1)',
          zIndex: 10,
        };
      case 'left-1':
        return {
          ...baseStyle,
          transform: 'translateX(-27vh) scale(1)',
          zIndex: 5,
        };
      case 'left-2':
        return {
          ...baseStyle,
          transform: 'translateX(-52vh) scale(1)',
          zIndex: 1,
        };
      case 'right-1':
        return {
          ...baseStyle,
          transform: 'translateX(27vh) scale(1)',
          zIndex: 5,
        };
      case 'right-2':
        return {
          ...baseStyle,
          transform: 'translateX(52vh) scale(1)',
          zIndex: 1,
        };
      case 'hidden':
        return {
          ...baseStyle,
          opacity: 0,
          pointerEvents: 'none',
        };
      default:
        return baseStyle;
    }
  };

  // Scroll to section
  const scrollToSection = (prefix: string) => {
    if (!renderComponents || !sectionRefs?.current) return;

    const firstSectionIndex = renderComponents.findIndex(
      (comp) => comp.id && comp.id.startsWith(prefix)
    );

    if (firstSectionIndex !== -1 && sectionRefs.current[firstSectionIndex]) {
      const element = sectionRefs.current[firstSectionIndex];
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 95;

      window.scrollTo({
        top: offsetPosition,
        // behavior: "smooth"
      });
    }
  };

  // Handle card click
  const handleCardClick = (index: number, member: any) => {
    if(!!member.path) {
      History.navigate(member.path);
    } else {
      setCurrentIndex(index);
      scrollToSection(member.prefix);
    }
  };

  // Update currentIndex when activePrefix changes
  useEffect(() => {
    if (activePrefix) {
      const index = stickyHeaderItems.findIndex(item => item.prefix === activePrefix);
      if (index !== -1) {
        setCurrentIndex(index);
      }
    }
  }, [activePrefix]);

  // Track scroll position and active section
  useEffect(() => {
    const handleScroll = () => {
      // Control visibility based on scroll position
      if (showWhen === 'scroll') {
        setIsVisible(window.scrollY > scrollThreshold);
      }

      // If activePrefix is provided, don't auto-track sections
      if (activePrefix) return;

      // Track which section is in view
      if (sectionRefs?.current && sectionRefs.current.length > 0) {
        const scrollPosition = window.scrollY + window.innerHeight / 2;

        for (let i = 0; i < sectionRefs.current.length; i++) {
          const section = sectionRefs.current[i];
          if (section) {
            const sectionTop = section.offsetTop;
            const sectionBottom = sectionTop + section.offsetHeight;

            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
              const sectionId = renderComponents[i]?.id;
              if (sectionId) {
                const itemIndex = getItemIndexFromSectionId(sectionId);
                setCurrentIndex(itemIndex);
              }
              break;
            }
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check
    return () => window.removeEventListener('scroll', handleScroll);
  }, [renderComponents, sectionRefs, showWhen, scrollThreshold, activePrefix]);

  // Don't render if not visible
  if (!isVisible) return null;

  return (
    // <div className='fixed top-0 left-0 z-50 w-full'>
    <div className='z-50 w-full'>
      {/* Sticky Header Content */}
      <div className="bg-[white] py-10 md:py-10 w-full flex justify-between md:justify-center items-center">
        {/* Carousel Cards */}
        <div className="flex flex-1 justify-center items-center transition-all duration-300">
          {stickyHeaderItems.map((member, index) => {
            const position = getCardPosition(index);
            const isActive = currentIndex === index;

            return (
              <div
                key={`sticky-card-${index}`}
                className={classNames(
                  "absolute flex items-center p-2 gap-2 rounded-xl cursor-pointer transition-all duration-300",
                  "bg-[#F4F4F4]"
                )}
                style={{
                  ...getCardStyles(position),
                  ...(isActive && {
                    border: `3px solid ${member.glowColor}`,
                    boxShadow: `0 0 20px ${member.glowColor}, 0 0 40px ${member.glowColor}80`,
                    backgroundColor: 'white'
                  })
                } as React.CSSProperties}
                onClick={() => handleCardClick(index, member)}
              >
                <div className={classNames("rounded flex items-center justify-center p-2", member.bg)}>
                  {member.icon}
                </div>

                <div className="flex flex-col">
                  <h3 className="text-[2vh] font-semibold text-gray-900">{member.role}</h3>
                  <p className="text-[1.7vh] text-gray-700">{member.des}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Invisible spacer for layout balance */}
        {onScrollUp && (
          <div className="invisible md:hidden flex items-center gap-3">
            <img src="images/newRedLogo.svg" alt="Logo" className='w-40' />
          </div>
        )}
      </div>
    </div>
  );
};

export default StickyHeader;